import React, { Component } from "react";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import MenuDrawer from "./MenuDrawer";

const lang = "";

class CommonMenu extends Component {
  constructor(props) {
    super(props);
    this.lang = props.lang ? props.lang : "";
  }

  getLangText(langJson) {
    return this.lang ? langJson[this.lang] : langJson["tc"];
  }

  getLink(page) {
    if (page == "") {
      return this.lang ? "/" + this.lang : "/" + page;
    } else {
      return this.lang ? "/" + this.lang + "/" + page : "/" + page;
    }
  }

  render() {
    return CommonMenuJSX(this);
  }
}

const CommonMenuJSX = ctx => (
  <div id="common-menu-container">
    <div id="menu" style={{ zIndex: 1000, lineHeight: "80pt", width: "100%" }}>
      <Grid
        container
        justify="flex-end"
        spacing={0}
        style={{ lineHeight: "36px" }}
      >
        <Grid item>
          <Button color="default">
            <Link
              to={ctx.getLink("")}
              style={{ textDecoration: "none", color: "rgb(245, 120, 42)" }}
            >
              <span className="menu-item-text">
                {ctx.getLangText({
                  tc: "首頁",
                  sc: "首页",
                  en: "Home"
                })}
              </span>
            </Link>
          </Button>
        </Grid>
        <Grid item style={{ position: "relative" }}>
          <Button
            color="default"
            onMouseEnter={mouseEnter}
            onMouseLeave={mouseLeave}
            style={{ width: "100%" }}
          >
            <Link
              to={ctx.getLink("about-us")}
              style={{ textDecoration: "none", color: "rgb(245, 120, 42)" }}
            >
              <span className="menu-item-text">
                {ctx.getLangText({
                  tc: "關於我們",
                  sc: "关于我们",
                  en: "About Us"
                })}
              </span>
            </Link>
          </Button>
          {/* <div
            className="menu-item"
            style={{
              position: "absolute",
              opacity: 1,
              padding: "inherit",
              top: "36px"
            }}
          >
            <div>
              <Button style={{ width: "100%", justifyContent: "flex-start" }}>
                <Link
                  to={ctx.getLink("about-us")}
                  style={{ textDecoration: "none" }}
                >
                  <span className="menu-item-text menu-sub-item-text">
                    {ctx.getLangText({
                      tc: "集團介紹",
                      sc: "集团介绍",
                      en: "Introduction"
                    })}
                  </span>
                </Link>
              </Button>
            </div>
            <div>
              <Button style={{ width: "100%", justifyContent: "flex-start" }}>
                <Link
                  to={ctx.getLink("awards-recognitions")}
                  style={{ textDecoration: "none" }}
                >
                  <span className="menu-item-text menu-sub-item-text">
                    {ctx.getLangText({
                      tc: "獎項殊榮",
                      sc: "奖项殊荣",
                      en: "Awards & Recognitions"
                    })}
                  </span>
                </Link>
              </Button>
            </div>
          </div> */}
        </Grid>
        <Grid item style={{ position: "relative" }}>
          <Button
            onMouseEnter={mouseEnter}
            onMouseLeave={mouseLeave}
            style={{ width: "100%" }}
          >
            <Link
              to={ctx.getLink("forex")}
              style={{ textDecoration: "none", color: "rgb(245, 120, 42)" }}
            >
              <span className="menu-item-text">
                {ctx.getLangText({
                  tc: "公司業務",
                  sc: "公司业务",
                  en: "Businesses"
                })}
              </span>
            </Link>
          </Button>
          <div
            className="menu-item"
            style={{
              position: "absolute",
              opacity: 1,
              padding: "inherit",
              top: "36px"
            }}
          >
            <div>
              <Button style={{ width: "100%", justifyContent: "flex-start" }}>
                <Link
                  to={ctx.getLink("forex")}
                  style={{ textDecoration: "none" }}
                >
                  <span className="menu-item-text menu-sub-item-text">
                    {ctx.getLangText({
                      tc: "技術咨詢",
                      sc: "技术咨询",
                      en: "Technology Consulting"
                    })}
                  </span>
                </Link>
              </Button>
            </div>

            {/*
							<div>
								<Button style={{ width: "100%", justifyContent: "flex-start" }}>
									<Link
										to={ctx.getLink("precious-metals")}
										style={{ textDecoration: "none" }}
									>
										<span className="menu-item-text menu-sub-item-text">
											{ctx.getLangText({
												tc: "貴金屬",
												sc: "贵金属",
												en: "Precious Metals"
											})}
										</span>
									</Link>
								</Button>
							</div>
							*/}

            <div>
              <Button style={{ width: "100%", justifyContent: "flex-start" }}>
                <Link
                  to={ctx.getLink("asset-management")}
                  style={{ textDecoration: "none" }}
                >
                  <span className="menu-item-text menu-sub-item-text">
                    {ctx.getLangText({
                      tc: "運營咨詢",
                      sc: "运营咨询",
                      en: "Operations Consulting"
                    })}
                  </span>
                </Link>
              </Button>
            </div>
          </div>
        </Grid>
        {/*
        <Grid item style={{ position: "relative" }}>
          <Button
            color="default"
            onMouseEnter={mouseEnter}
            onMouseLeave={mouseLeave}
            style={{ width: "100%" }}
          >
            <Link
              to={ctx.getLink("press-center")}
              style={{ textDecoration: "none", color: "rgb(245, 120, 42)" }}
            >
              <span className="menu-item-text">
                {ctx.getLangText({
                  tc: "最新消息",
                  sc: "最新消息",
                  en: "News"
                })}
              </span>
            </Link>
          </Button>
          <div
            className="menu-item"
            style={{
              position: "absolute",
              opacity: 1,
              padding: "inherit",
              top: "36px"
            }}
          >
            <div>
              <Button style={{ width: "100%", justifyContent: "flex-start" }}>
                <Link
                  to={ctx.getLink("press-center")}
                  style={{ textDecoration: "none", color: "rgb(245, 120, 42)" }}
                >
                  <span className="menu-item-text menu-sub-item-text">
                    {ctx.getLangText({
                      tc: "新聞中心",
                      sc: "新闻中心",
                      en: "Press Center"
                    })}
                  </span>
                </Link>
              </Button>
            </div>

            <div>
              <Button style={{ width: "100%" }}>
                <Link
                  to="/announcement"
                  style={{ textDecoration: "none", color: "rgb(245, 120, 42)" }}
                >
                  <span className="menu-item-text">公告</span>
                </Link>
              </Button>
            </div>
          </div>
        </Grid>
			*/}

        <Grid item>
          <Button>
            <Link
              to={ctx.getLink("contact-us")}
              style={{ textDecoration: "none", color: "rgb(245, 120, 42)" }}
            >
              <span className="menu-item-text">
                {ctx.getLangText({
                  tc: "聯絡我們",
                  sc: "联络我们",
                  en: "Contact Us"
                })}
              </span>
            </Link>
          </Button>
        </Grid>
      </Grid>
    </div>
    <div id="responsive-menu-button">
      <MenuDrawer />
    </div>
  </div>
);

function mouseEnter(event) {
  event.currentTarget.parentNode.className += " sfhover";
}

function mouseLeave(event) {
  event.currentTarget.parentNode.className = event.currentTarget.parentNode.className.replace(
    new RegExp(" sfhover\\b"),
    ""
  );
}

export default CommonMenu;



// WEBPACK FOOTER //
// ./src/components/pages/includes/CommonMenu.js